import { render, staticRenderFns } from "./ActionPage.vue?vue&type=template&id=304190e8&"
import script from "./ActionPage.vue?vue&type=script&lang=js&"
export * from "./ActionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports